import gql from 'graphql-tag';
import { CustomAttribute } from '../../../models/customAttribute';
import { Metafield } from '../../../models/metafield';
import { META_NAMESPACE } from '../../../utils/types';

const OrderEditableFieldsFragment = gql`
  fragment OrderEditableFields on Order {
    id
    tags
    customAttributes {
      key
      value
    }
    metafields(first: 10, namespace: "${META_NAMESPACE}") {
      edges {
        node {
          id
          key
          value
        }
      }
    }
  }
`;

export default OrderEditableFieldsFragment;

export type OrderEditableFields = {
    id: string,
    tags: string[],
    customAttributes: CustomAttribute[],
    metafields: {
        edges: {
            node: Metafield,
        }[],
    },
};